import qs from "qs";
import request from "@/utils/requestSC";
import requestApi from "@/utils/requestApi";
// 车辆列表
export async function getVehicleList(params = {}) {
  return requestApi.post("/scbasic/member/membervehicle/selMemberVehicleList", params);
}

// 添加车辆
export async function addVehicle(params = {}) {
  return requestApi.post("/scbasic/member/membervehicle/add", params);
}

// /openapi/scbasic/member/membervehicle/del

// 更新单个收货信息
export async function delVehicle(params = {}) {
  return requestApi.post("/scbasic/member/membervehicle/del", params);
}

export async function membervehicleEdit(params = {}) {
  return requestApi.post("/scbasic/member/membervehicle/edit", params);
}
